module.exports = __webpack_public_path__ + "static/media/01-home.72df010a.png";